import React, { useContext, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useParams, useLocation, useNavigate } from 'react-router-dom';
import { AppContext } from '../../contexts';
import { getUserData } from '../../utils/storage';
import styles from './styles.scoped.css';
import TabelHarga from './TabelHarga';
import SubUser from './SubUser';
import Tab from '../../components/elements/Tab/Tab';

export default function SettingHarga() {
  const { setBreadcrumbs } = useContext(AppContext);

  const navigate = useNavigate();
  const isLaAdmin = getUserData()?.isLinkAjaAdmin;
  useEffect(() => {
    if (isLaAdmin) {
      navigate('/registrasi-merchant');
    }
  }, [isLaAdmin]);

  const { dataProductCategories } = useSelector((s) => s.pageBase);

  const { type } = useParams();

  const [category, setCategory] = useState(null);

  const tabList = [
    { label: 'Pangkalan', value: 'pangkalan' },
    { label: 'Subpangkalan', value: 'subpangkalan' },
  ];
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const activeTab = searchParams.get('tab') || 'pangkalan';
  const handleChangeTab = (val) => {
    const newSearchParams = new URLSearchParams(location.search);
    newSearchParams.set('tab', val);
    navigate({
      pathname: location.pathname,
      search: newSearchParams.toString(),
    });
  };

  useEffect(() => {
    // const findCategory = dataProductCategories.find(
    //   (c) => c.name.toLowerCase().trim() === type
    // );
    // if (findCategory) {
    setCategory({
      categoryId: 'f4fe295d-768e-40ba-92c5-ebfa772cbb85',
      name: 'LPG',
      unit_symbol: 'Tabung',
      unit_name: 'Tabung',
    });
    setBreadcrumbs(['Atur HET LPG 3 Kg']);
    // }
  }, [type, dataProductCategories]);

  return (
    <div className={styles.root}>
      <Tab data={tabList} defaultValue={activeTab} onChange={handleChangeTab} />
      {activeTab === 'pangkalan' ? (
        <TabelHarga category={category} />
      ) : (
        <SubUser category={category} />
      )}
    </div>
  );
}
